import { useState, useEffect } from 'react';
import { ACTION_DELETE, ACTION, Action, ACTION_EDIT_SUBMIT, ACTION_EDIT } from '../../../component/table/interfaces/TableInterface';
import { ResearchQuestionInterface } from '../interfaces/ResearchQuestion';
import { deleteResearchQuestion, getByIdResearchQuestion, getResearchQuestion, getRatingQuestions, deleteValueSearch, deleteTypeOriginQuestion } from '../Assesment.service';
import ModalDelete from '../../../component/modal/ModalDelete.component';
import GridComponent from '../../../component/grid/GridComponent.component';
import { Title } from '../../../component/title/Title';
import Table from '../../../component/table/Table.component';
import useModal from '../../../hooks/useModal';
import Modal from '../../../component/modal/Modal.component';
import ButtonLink from "../../../component/buttton/ButtonLink.component";
import Details from "../operationalIndicator/Details.component";
import { RatingQuestion } from '../interfaces/RatingQuestion';
import { useSnackbar } from '../../../context/Snackbar';
import { useHistory } from 'react-router-dom';
import Form from '../register/Form.component';


export default function EvaluationItemsComponent() {

    const { setSnackbar } = useSnackbar();
    const [evaluationItems, setEvaluationItems] = useState<ResearchQuestionInterface[]>([]);
    const [open, addModal] = useModal();
    const [request, setRequest] = useState<boolean>(true);
    const [submit, setSubmit] = useState<boolean>(false);
    let history = useHistory();

    useEffect(() => {
        getListAssessments()
    }, [request]);

    async function getListAssessments() {
        setTimeout(async () => {
            await getResearchQuestion().then(res => {
                setEvaluationItems(res.data);
            }).catch((error) => {
                console.log("Erro ao consultar itens de avaliação", error);
            }).finally(() => {
                setRequest(false);
        })}, 1000*1.5)
    }

    const handleClickAction = (action: Action, question: ResearchQuestionInterface) => {
        if (action === ACTION_DELETE) {
            return addModal(question.id);
        }

        if (action === ACTION_EDIT) {
            return history.push(`/avaliacao-loja/editar-avaliacao/${question.id}`);
        }
    }

    const handleClickDelete = async () => {
        setSubmit(true)
        const ratings: RatingQuestion[] = await getRatingQuestions().then(res => {
            return res.data;
        })

        const idAssessment = String(open);
        const listResearchQuestionId = ratings.filter(item => item.idPerguntaPesquisa.id === idAssessment)

        if (listResearchQuestionId.length !== 0) {
            console.log("Item de pesquisa utilizado em avaliações")
            setSnackbar({msg: `Não foi possível excluir o item de pesquisa!`, type: 'error'})
            addModal(undefined);
            setSubmit(false);
        } else {
            setTimeout(async () => {
                await getByIdResearchQuestion(String(open)).then(res => {
                    console.log("Data aqui: ", res.data)
                    deleteAssessmentById(res.data)
                }).catch(error => {
                    setSnackbar({msg: "Erro ao exluir item de pesquisa!", type: 'error'})
                }).finally(function () {
                    addModal(undefined);
                    setSubmit(false);
                })
            }, 1000*1.5)
        }
    }

    async function deleteAssessmentById(data: ResearchQuestionInterface) {
        setTimeout(async () => {
            await deleteResearchQuestion(data.id).then(res => {
                setSnackbar({msg: `Item de pesquisa excluído com sucesso!`, type: 'success'});

                if (data.idValoresPesquisa.id) {
                    deleteValueSearchById(data.idValoresPesquisa.id);
                }

                if (data.idTipoOrigemPergunta.id) {
                    deleteTypeOriginQuestionById(data.idTipoOrigemPergunta.id);
                }

            })
        }, 1000*1.5)
        
    }

    async function deleteValueSearchById(id: string) {
        setTimeout(async () => {
            await deleteValueSearch(id).then(res => {

            })
        }, 1000*1.5)
    }

    async function deleteTypeOriginQuestionById(id: string) {
        setTimeout(async () => {
            await deleteTypeOriginQuestion(id).then(res => {

            })
        }, 1000*1.5)
    }

    return (
        <>
        <Details />
        <br />
            <GridComponent justify='space-between'>
                <Title>Itens de Avaliação</Title>
                <ButtonLink title='Adicionar novos itens' link={`/avaliacao-loja/cadastrar-avaliacao`} size='medium'  />
            </GridComponent>
            <ModalDelete open={!!open && open !== true} handleClick={() => addModal(undefined)} onClickSubmit={handleClickDelete} title="Confirma a exclusão deste item de pesquisa?" disabled={submit} />
            <br />
            <br />
            <Table 
                request={request}
                data={evaluationItems}
                size={evaluationItems.length}
                headCells={[{ id: 'dsPesquisa', label: 'Título da Pergunta' }, { id: ACTION, label: 'Ação' }]}
                handleClickAction={handleClickAction}
                noActionView
                editable={true}
            />
        </>
    );
}